import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
export var UPDATE = "REDUX_ORM_UPDATE";
export var DELETE = "REDUX_ORM_DELETE";
export var CREATE = "REDUX_ORM_CREATE";
export var FILTER = "REDUX_ORM_FILTER";
export var EXCLUDE = "REDUX_ORM_EXCLUDE";
export var ORDER_BY = "REDUX_ORM_ORDER_BY";
export var SUCCESS = "SUCCESS";
export var FAILURE = "FAILURE"; // for detecting ORM state objects

export var STATE_FLAG = "@@_______REDUX_ORM_STATE_FLAG"; // for caching selectors based on their ID argument

export var ALL_INSTANCES = Symbol("REDUX_ORM_ALL_INSTANCES");
export var ID_ARG_KEY_SELECTOR = function ID_ARG_KEY_SELECTOR(_state, idArg) {
  return typeof idArg === "undefined" ? ALL_INSTANCES : idArg;
};